export var PostPopupMode = /*#__PURE__*/ function(PostPopupMode) {
    PostPopupMode["JOURNAL"] = "journal";
    PostPopupMode["STATUS"] = "status";
    return PostPopupMode;
}({});

//# sourceMappingURL=types.js.map